import { ApplicationConfig } from '@angular/core';
import { provideRouter, UrlSerializer, DefaultUrlSerializer } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAnalytics, provideAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
import { FIREBASE_CONFIG } from './app.const';
import { GalleryUrlSerializer } from './gallery-url/gallery-url.serializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideFirebaseApp(() => initializeApp(FIREBASE_CONFIG)),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    DefaultUrlSerializer,
    { provide: UrlSerializer, useClass: GalleryUrlSerializer },
  ],
};
